
import Vue from "vue";
import {RunningJob} from "@/utils/running-job";
import { CompanyService, MainSocketService, MetricService } from "@/services";

export default Vue.extend({
	data(){
		return {
			jobs: [] as RunningJob[]
		};
	},
	methods: {
		async openDossier(dossierId:number){
			let company = await CompanyService.getCompanyByDossierID(dossierId);
			this.$router.push(`/companies/${company.id}/dossier/${dossierId}/info`);
		},
		async openCompany(dossierId:number){
			let company = await CompanyService.getCompanyByDossierID(dossierId);
			this.$router.push(`/companies/${company.id}/info`);
		},
		async fetch(){
			this.jobs = await MetricService.getRunningJobs();
		},
		addJob(job:RunningJob){
			for (let j of this.jobs) {
				if (j.isSameJob(job)){
					return;
				}
			}
			this.jobs.push(job);
		},
		removeJob(job:RunningJob){
			for (let i = this.jobs.length - 1; i>=0;i--){
				if (this.jobs[i].isSameJob(job)){
					this.jobs.splice(i,1);
				}
			}
		},
		onJobStarted(data:any){
			let job = new RunningJob(data);
			this.addJob(job);
		},
		onJobStopped(data:any){
			let job = new RunningJob(data);
			this.removeJob(job);
		}
	},
	async created(){
		await this.fetch();
		MainSocketService.on("job-started", this.onJobStarted);
		MainSocketService.on("job-stopped", this.onJobStopped);
	},
	destroyed(){
		MainSocketService.off("job-started", this.onJobStarted);
		MainSocketService.off("job-stopped", this.onJobStopped);
	}
});
